
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "16px",
    "height": "16px",
    "viewBox": "0 0 16 16",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "大地原点"
        }
      ]
    },
    {
      "tag": "defs",
      "children": [
        {
          "tag": "filter",
          "attrsMap": {
            "id": "filter-1"
          },
          "children": [
            {
              "tag": "feColorMatrix",
              "attrsMap": {
                "in": "SourceGraphic",
                "type": "matrix",
                "values": "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0.850000 0"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "页面-1",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "监控页-单车单摄像头",
            "transform": "translate(-1124.000000, -287.000000)"
          },
          "children": [
            {
              "tag": "g",
              "attrsMap": {
                "id": "原点",
                "transform": "translate(952.000000, 278.000000)"
              },
              "children": [
                {
                  "tag": "g",
                  "attrsMap": {
                    "id": "大地原点",
                    "transform": "translate(-0.000000, 0.000000)",
                    "filter": "url(#filter-1)"
                  },
                  "children": [
                    {
                      "tag": "g",
                      "attrsMap": {
                        "transform": "translate(172.000000, 9.000000)"
                      },
                      "children": [
                        {
                          "tag": "rect",
                          "attrsMap": {
                            "id": "矩形",
                            "fill": "#000000",
                            "fill-rule": "nonzero",
                            "opacity": "0",
                            "x": "0",
                            "y": "0",
                            "width": "16",
                            "height": "16"
                          }
                        },
                        {
                          "tag": "path",
                          "attrsMap": {
                            "d": "M7.9999953,1.81819148 C5.94091618,1.81819148 4.08458725,3.05855081 3.29661178,4.96089186 C2.50863631,6.86323291 2.94419258,9.05292218 4.40018139,10.508911 C5.85617019,11.9648998 8.04585946,12.4004561 9.94820052,11.6124806 C11.8505416,10.8245052 13.0909009,8.96817623 13.0909009,6.90909711 C13.0909009,4.09746758 10.8116248,1.81819148 7.9999953,1.81819148 Z M11.8181745,7.45455128 L8.54544947,7.45455128 L8.54544947,10.7272763 C8.54544947,11.0285224 8.30124131,11.2727305 7.99999529,11.2727305 C7.69874926,11.2727305 7.45454111,11.0285224 7.45454111,10.7272763 L7.45454111,7.45455128 L4.18181608,7.45455128 C3.88057006,7.45455128 3.63636191,7.21034313 3.63636191,6.90909711 C3.63636191,6.60785109 3.88057006,6.36364294 4.18181608,6.36364294 L7.45454111,6.36364294 L7.45454111,3.09091789 C7.45454111,2.78967187 7.69874926,2.54546371 7.99999529,2.54546371 C8.30124131,2.54546371 8.54544947,2.78967187 8.54544947,3.09091789 L8.54544947,6.36364294 L11.8181745,6.36364294 C12.1194205,6.36364294 12.3636287,6.60785109 12.3636287,6.90909711 C12.3636287,7.21034313 12.1194205,7.45455128 11.8181745,7.45455128 Z M7.9999953,-1.55680896e-06 C4.53367007,-0.00652258303 1.59905915,2.55644366 1.13900737,5.99211035 C0.678955584,9.42777705 2.83588657,12.6725245 6.1818147,13.5781835 C7.04790976,14.15281 7.68990734,15.0079507 7.9999953,15.9999984 C8.31008325,15.0079507 8.95208083,14.15281 9.81817588,13.5781835 C13.164104,12.6725245 15.321035,9.42777705 14.8609832,5.99211036 C14.4009314,2.55644367 11.4663205,-0.00652257513 7.9999953,-1.55680896e-06 Z M7.9999953,12.727275 C4.7867044,12.727275 2.18181745,10.122388 2.18181745,6.90909711 C2.18181745,3.69580621 4.7867044,1.09091927 7.9999953,1.09091927 C11.2132862,1.09091927 13.8181731,3.69580621 13.8181731,6.90909711 C13.8181731,10.122388 11.2132862,12.727275 7.9999953,12.727275 Z",
                            "id": "形状",
                            "fill": "#000000",
                            "fill-rule": "nonzero"
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  